import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: '',
    userInfo: {}
  },
  mutations: {
    token(state, token) {
      state.token = token
    },
    userInfo(state, userInfo) {
      state.userInfo = userInfo
    }
  }
})

export default store
